export enum LogicalOperator{
    And,
    Or
}